var voucherCash = "https://shopfront-cdn.tekoapis.com/static/1217c4c74ed67be1.svg";

export { voucherCash as default };
